import axios from 'axios';

import { serverErrorCode, serverErrorDetail, useAlertsStore } from '@tallo/design-system';
import { propertyAccessRequiredErrorCode, usePropertyAccessDialogStore } from '@tallo/investor/property';

/**
 * A change refused because the seat can view the unit or building but does not work on it opens the
 * dialog that offers to ask its manager, wherever the change was made from. The refusal still
 * reaches the caller; its error toast is held back, since the dialog already says what happened.
 */
export function installPropertyAccessInterceptor(): void {
  axios.interceptors.response.use(undefined, (error) => {
    if (error?.response?.status === 403 && serverErrorCode(error) === propertyAccessRequiredErrorCode) {
      // A refusal about a building names the building in place of a unit
      const buildingId = serverErrorDetail(error, 'buildingId');
      const [id, kind] =
        typeof buildingId === 'string'
          ? [buildingId, 'building' as const]
          : [serverErrorDetail(error, 'propertyId'), 'property' as const];

      if (typeof id === 'string') {
        useAlertsStore().holdErrors(2000);
        usePropertyAccessDialogStore().open(id, kind);
      }
    }

    return Promise.reject(error);
  });
}
